/**
 * Генерирует правильный UUID v4 в формате xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 * @returns {string} UUID в правильном формате
 */
export function generateUUID() {
  // Используем криптографически стойкий генератор случайных чисел
  const randomBytes = new Uint8Array(16);
  crypto.getRandomValues(randomBytes);
  
  // Конвертируем случайные байты в UUID v4 формат
  const hex = Array.from(randomBytes, byte => byte.toString(16).padStart(2, '0')).join('');
  
  return [
    hex.substring(0, 8),
    hex.substring(8, 12),
    '4' + hex.substring(13, 16), // Версия 4
    ((parseInt(hex.substring(16, 17), 16) & 0x3) | 0x8).toString(16) + hex.substring(17, 20), // Variant bits
    hex.substring(20, 32)
  ].join('-');
}

/**
 * Получает или создает device_uuid для текущего пользователя
 * @returns {string} Валидный device_uuid
 */
export function getOrCreateDeviceUUID() {
  let deviceUuid = localStorage.getItem('guest_id');
  
  // Проверяем формат UUID (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
  const uuidPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
  
  if (!deviceUuid || !uuidPattern.test(deviceUuid)) {
    deviceUuid = generateUUID();
    localStorage.setItem('guest_id', deviceUuid);
  }
  
  return deviceUuid;
} 